// utils/dateFormatter.js
export const formatDate = (date) => {
  if (!date) return "";

  const options = { day: "2-digit", month: "short", year: "numeric" };
  return new Date(date).toLocaleDateString("en-GB", options);
};
